export default "__VITE_ASSET__DGJ5I2Ee__"